import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import LastSubscription from "./DerniereSouscriptionList/reducer";
import Sas from "./SasList/reducer";
import DossierComplet from "./DossierCompletList/reducer";
import MontantInvest from "./MontantInvestList/reducer";
import DossierValide from "./DossierValideList/reducer";
import SyntheseAnnuelle from "./SyntheseAnnuelle/reducer";
import DocumentationReglementaire from "./DocumentationReglementaire/reducer";
import DerniereReser from "./DernieresReserv/reducer";
import Investisseurs from "./Investisseurs/reducer";
import FiltreInvestisseurs from "./FiltreInvestisseurs/reducer";
import FiltreR from "./FiltreReservations/reducer";
import FiltreReservationsEnCours from "./FiltreReservationsEnCours/reducer";
import FiltreSouscriptions from "./FiltreSouscriptions/reducer";
import FiltreParticipations from "./FiltreParticipations/reducer";
import DerniersDocs from "./DerniersDocs/reducer";
import SyntheseAnnee from "./SyntheseAnnée/reducer";
import FiltrePme from "./FiltrePmes/reducer";
import FiltreReservationSuivi from "./FiltreReservationSuivi/reducer";
import FiltreInvestissements from "./FiltreInvestissements/reducer";
import FiltreCgps from "./FiltreCgps/reducer";
import FiltrePCgps from "./FiltrePartenairesCgps/reducer";
import FiltrePExpl from "./FiltrePartenairesExploitants/reducer";
import FiltrePIndu from "./FiltrePartenairesIndustriels/reducer";
import FiltrePdp from "./FiltrePartenairesDirectionP/reducer";
import FiltreModelInvest from "./FiltreModeleInvestisseur/reducer";
import FiltreModelReserv from "./FiltreModeleReservation/reducer";
import FiltreModelSouscription from "./FiltreModeleSouscription/reducer";
import FiltreModelPme from "./FiltreModelePmes/reducer";
import FiltreModelInvestissement from "./FiltreModeleInvestissement/reducer";
import FiltreModelLoyer from "./FiltreModeleLoyer/reducer";
import FiltreModelAugCap from "./FiltreModeleAugCap/reducer";
import FiltreImpression from "./FiltreImpression/reducer";
import FiltreUsers from "./FiltreUsers/reducer";
import FiltreTickets from "./FiltreTickets/reducer";
import FiltreFactures from "./FiltreFactures/reducer";
import FiltreMesDocuments from "./FiltreMesDocuments/reducer";
import FiltreConfigMessagerie from "./FiltreConfigMessagerie/reducer";
import FiltreMessage from "./FiltreMessage/reducer";
import FiltreProjets from "./FiltreProjets/reducer";
import FiltreFxFacturation from "./FiltreFxFacturation/reducer";
import FiltreBaseCalcul from "./FiltreBaseCalcul/reducer";

const rootReducer = combineReducers({
  // public
  Investisseurs,
  SyntheseAnnee,
  DerniereReser,
  DossierValide,
  MontantInvest,
  LastSubscription,
  Sas,
  DossierComplet,
  SyntheseAnnuelle,
  DocumentationReglementaire,
  FiltreInvestisseurs,
  FiltreR,
  FiltreReservationsEnCours,
  FiltreSouscriptions,
  FiltreParticipations,
  FiltreReservationSuivi,
  FiltrePme,
  FiltreCgps,
  DerniersDocs,
  FiltreInvestissements,
  FiltrePCgps,
  FiltrePExpl,
  FiltrePIndu,
  FiltrePdp,
  FiltreModelInvest,
  FiltreModelInvestissement,
  FiltreModelReserv,
  FiltreModelSouscription,
  FiltreModelPme,
  FiltreModelLoyer,
  FiltreModelAugCap,
  FiltreImpression,
  FiltreUsers,
  FiltreTickets,
  FiltreFactures,
  FiltreMesDocuments,
  FiltreConfigMessagerie,
  FiltreMessage,
  FiltreProjets,
  FiltreFxFacturation,
  FiltreBaseCalcul,
  // private
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
});

export default rootReducer;
